import { DocumentoDestinatario } from './documentoDestinatario.model';
import { DocumentoProgressivo } from './documentoProgressivo.model';
import { Posizione } from './posizione.model';
import { Riferimento } from './riferimento';
import { StatiPredefiniti } from './stati-predefiniti';
import { StoricoStatoDocumento } from './storicoStatoDocumento.model';

export interface Documento {
  documentoId: number;
  protocollo: string;
  dataDocumento?: Date;
  dataInvio?: Date;
  dataProtocollazione?: Date;
  oggetto: string;
  mittenteId?: number;
  autoreId?: number | null;
  documentoDestinatario?: DocumentoDestinatario[];
  protocolloMittente: string;
  classificaId: number;
  classificaOriginaleId: number;
  qualificaId: number;
  sezioneId: number;
  statoId: number | StatiPredefiniti;
  esercitazione: boolean;
  dataScadenza?: Date;
  posizioneId: string | Posizione[];
  arrivo: boolean;
  note: string;
  paroleChiave?: string[];
  lingua: string;
  documentoAnalogico?: boolean;
  prodottoSoftwareId?: number | null;
  numeroPagine?: number | null;
  organoSicurezzaOriginatore?: string | null;
  organoSicurezzaDestinatario?: string | null;
  caveatDiSicurezzaId?: number | null;
  caveatDiSicurezzaAltro?: string | null;
  modalitaFormazioneId?: number | null;
  tipoDocumentoId?: number | null;
  ambitoUtilizzoId?: number | null;
  bloccato: boolean;
  riproduzione?: boolean;
  precedenzaId: number;
  noCarico: boolean;
  numeroControllo: string | null;
  numeroEsemplariRicevuti: string | null;
  numeroDistintoCopie: string | null;
  numeroAllegati: string | null;
  copieInCarico: string | null;
  gerarchia: Posizione[];
  storicoStatiDocumento?: StoricoStatoDocumento[];
  riferimento: Riferimento[];
  documentoProgressivo: DocumentoProgressivo[];
  ambito?: string;
  dataScadenzaClassifica?: Date;
  posizione?: Posizione[];
  noteEtichetta?: string;
  numeroCarico?: number;
  scaricaAllegati?: boolean;
  versione?: number;
  tipoModifica?: string;
}

export enum Direction {
  Arrivo = 'arrivo',
  Partenza = 'partenza'
}
